import React from 'react';

export default ({ item }) => {
	return (
		<>
			<div className="py-6">
				<div className="flex justify-between"></div>
			</div>
		</>
	);
};
